<!-- 添加配送 -->
<template>
  <div class="content">
    <div class="bodycontent">
      <ul class="messageUl">
        <li class="messageIl">
          <div class="lileft">配送方式名称</div>
          <div class="liright flex">
            <el-input
              v-model="fakedata.name"
              style="width:33%"
            >
            </el-input>
            <span>最多输入20个字</span>
          </div>
        </li>
        <li class="messageIl">
          <div class="lileft">模板类型</div>
          <div class="liright">
            <el-radio label="1">买家承担运费</el-radio>
            <el-radio label="2">卖家包邮</el-radio>
          </div>
        </li>
        <li class="messageIl">
          <div class="lileft">计价方式</div>
          <div class="liright">
            <el-radio v-model="fakedata.calculate_type" label="1">买家承担运费</el-radio>
            <el-radio v-model="fakedata.calculate_type" label="2">卖家包邮</el-radio>
          </div>
        </li>
        <li class="messageIl">
          <div class="lileft">配送区域及运费</div>
          <div class="liright">
            <!-- 运费模板 -->
            <table class="freightTemplate">
              <thead>
                <tr>
                  <td>可配送区域</td>
                  <td class="live1">首件(件)</td>
                  <td class="live1">运费(元)</td>
                  <td class="live1">续件（件）</td>
                  <td class="live1">续费（元）</td>
                </tr>
              </thead>
              <tr>
                <td>
                  <el-checkbox v-model="is_areas">
                      所有地区默认配送
                  </el-checkbox>
                  <div>
                    （未勾选，则仅下列所选区域可配送）
                  </div>
                  
                </td>
                <td>
                  <el-input v-model="fakedata.firstnum"></el-input>
                </td>
                <td>
                  <el-input v-model="fakedata.firstprice"></el-input>
                </td>
                <td>
                  <el-input v-model="fakedata.secondnum"></el-input>
                </td>
                <td>
                  <el-input v-model="fakedata.secondprice"></el-input>
                </td>
              </tr>
              <tr>
                <td colspan="5">
                  <el-button
                  icon="el-icon-location-information"
                  >
                    点击添加可配送区域和运费
                  </el-button>
                </td>
              </tr>
            </table>
          </div>
        </li>
        <li class="messageIl">
          <div class="lileft"></div>
          <div class="liright">
            <el-checkbox v-model="is_model">
              设为新商品默认模板（新添加的商品支持商家配送时的默认模板）
            </el-checkbox>
          </div>
        </li>
      </ul>
      <div class="bottom">
        <el-button type="primary" @click="add">保存</el-button>
        <el-button @click = "goback">返回列表</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { addFreight, editFreights, uploadFreights } from "@/api/express";
import { mapGetters, mapMutations, mapActions, mapState } from "vuex";
export default {
  data () {
    return {
      is_areas: false,
      is_model: false,
      fakedata: {},
      formdata: {
        name: "",
        is_defautl: "",
        calculate_type: "1",
        express_id: "",
        areas: "",
        firstprice: "",
        secondprice: "",
        firstweight: "",
        secondweight: "",
        firstnum: "",
        firstnumprice: "",
        secondnum: "",
        secondnumprice: "",
        is_defautl_tpl: "",
      }
    };
  },
  computed: {
    ...mapGetters(["token", "app_id", "merch_id"]),
  },
  components: {},
  mounted(){
    // this.$route.query.jude 0 添加 1 编辑
    // this.$route.query.id 模板id
    if(this.$route.query.jude == 1){
      let data ={
        "token": this.token,
        "app_id": this.app_id,
        "id": this.$route.query.id,
      }
      this.sethttp("2");
      editFreights(data).then( res => {
        console.log("bianij", res);
        if( res.code == 200){
          this.fakedata = res.data;
          this.fakedata.calculate_type = String(this.fakedata.calculate_type);
          this.fakedata.is_defautl == 1 ? this.is_areas = true : this.is_areas = false;
          this.fakedata.is_defautl_tpl == 1 ? this.is_model = true : this.is_model = false;
        }else{
          this.$message({
            message: res.msg,
            type: "warning"
          })
        }
        this.sethttp("1");
      })
    }else{
      this.fakedata = this.formdata;
    }
  },
  methods:{
    ...mapActions(["sethttp"]),
    add(){
      this.fakedata.app_id = this.app_id;
      this.fakedata.merch_id = this.merch_id;
      this.fakedata.token = this.token;
      this.is_areas == true? this.fakedata.is_defautl = 1: this.fakedata.is_defautl = 0;
      this.is_model == true? this.fakedata.is_defautl_tpl = 1: this.fakedata.is_defautl_tpl = 0;
      console.log("shuju",this.fakedata);
      console.log("shujuJUDE",this.$route.query.jude);
      var data = this.fakedata;
      if(this.$route.query.jude == 0){
        this.sethttp("2");
        addFreight(data).then( res => {
          if( res.code == 1){
            this.$message({
              message: res.msg,
              type: "success",
            })
          }else{
            this.$message({
              message: res.msg,
              type: "warning"
            })
          }
          this.sethttp("1");
        })
      }else{
        this.sethttp("2");
        uploadFreights(data).then( res => {
          console.log("更新返回", res);
          if( res.code == 1){
            this.$message({
              message: res.msg,
              type: "success",
            })
          }else{
            this.$message({
              message: res.msg,
              type: "warning"
            })
          }
          this.sethttp("1");
        })
      }
    },
    goback(){
      this.$router.push("waybill")
    }
  }
}
</script>
<style lang= "scss" scoped>
@import "./public/style/_interfacePublic";
.content{
  padding: 0 48px 48px 27px;
  .bodycontent{
    height: 100%;
    .messageUl {
      width: 100%;
        // padding-left:50px;
      color: #595959;
      .messageIl {
        display: flex;
        margin-top: 25px;
        .flex{
          display:flex;
          align-items: center;
        }
        .lileft {
          width: 110px;
          text-align: right;
          .redopt {
            color: red;
            font-size: 10px;
          }
        }
        .liright {
          flex: 1;
          font-size: 12px;
          color: #999999;
          margin-left: 45px;
          /* 运费模板 */
          .freightTemplate {
            width: 80%;
            background: #fff;
            margin-top: 10px;
            border: 1px solid #f1f1f1;
            border-radius: 5%;
            thead{
              font-weight: 600;
              color: #595961;
              tr{
                /* display: flex; */
                .fixed{
                  width: 23%;
                }
                /* .live1{
                  flex: 1;
                } */
              }
              
            }
            tr {
              height: 40px;
              border-bottom:1px solid #f1f1f1;
            }
            td{
              padding:15px;
            }
          }
        }
      }
    }
    .bottom{
      margin-top:48px;
    }
  }
}
</style>